var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.875C5.5125 1.875 1.875 5.5125 1.875 10C1.875 14.4875 5.5125 18.125 10 18.125C14.4875 18.125 18.125 14.4875 18.125 10C18.125 5.5125 14.4875 1.875 10 1.875ZM10.4417 6.43333C10.3245 6.31629 10.1656 6.25055 10 6.25055C9.83437 6.25055 9.67552 6.31629 9.55833 6.43333L7.05833 8.93333C6.99693 8.99055 6.94768 9.05955 6.91352 9.13622C6.87936 9.21288 6.86099 9.29565 6.85951 9.37956C6.85803 9.46348 6.87346 9.54684 6.9049 9.62466C6.93633 9.70249 6.98312 9.77318 7.04247 9.83253C7.10182 9.89188 7.17251 9.93867 7.25034 9.9701C7.32816 10.0015 7.41152 10.017 7.49543 10.0155C7.57935 10.014 7.66212 9.99564 7.73878 9.96148C7.81545 9.92732 7.88445 9.87807 7.94167 9.81667L9.375 8.38333V13.125C9.375 13.2908 9.44085 13.4497 9.55806 13.5669C9.67527 13.6842 9.83424 13.75 10 13.75C10.1658 13.75 10.3247 13.6842 10.4419 13.5669C10.5592 13.4497 10.625 13.2908 10.625 13.125V8.38333L12.0583 9.81667C12.1156 9.87807 12.1846 9.92732 12.2612 9.96148C12.3379 9.99564 12.4206 10.014 12.5046 10.0155C12.5885 10.017 12.6718 10.0015 12.7497 9.9701C12.8275 9.93867 12.8982 9.89188 12.9575 9.83253C13.0169 9.77318 13.0637 9.70249 13.0951 9.62466C13.1265 9.54684 13.142 9.46348 13.1405 9.37956C13.139 9.29565 13.1206 9.21288 13.0865 9.13622C13.0523 9.05955 13.0031 8.99055 12.9417 8.93333L10.4417 6.43333Z",
    fill: "#CDCED6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.1b5cee755f13e6ae40c1850546168a1b.svg";
export { ForwardRef as ReactComponent };